import { Component, OnInit } from '@angular/core';
import { FormArray } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';
import { Service, ServicePackaging } from 'src/app/services/interface';
import { ServicesService } from 'src/app/services/services.service';
import Swal from 'sweetalert2';
import { ServiceFormService } from '../service-form.service';

@Component({
  selector: 'app-service-pricing',
  templateUrl: './service-pricing.component.html',
  styleUrls: ['./service-pricing.component.scss']
})
export class ServicePricingComponent implements OnInit {
  public service: Service;
  public selectedPackage = 0;
  public unitsOfMeasure$ = this.servicesService.unitsOfMeasure$

  constructor(
    private route: ActivatedRoute,
    private serviceFormService: ServiceFormService,
    private servicesService: ServicesService,
  ) { }

  ngOnInit(): void {
    this.route.parent.data.subscribe(data => {
      this.service = data.serviceDetails;
    })
    this.servicesService.getUnitsOfMeasure().subscribe()
  }

  public selectPackage(index: number) {
    this.selectedPackage = index;
  }

  public get serviceFormGroup() {
    return this.serviceFormService.serviceFormGroup
  }

  public get packagingForm() {
    return this.serviceFormService.packagingForm
  }

  public addPackage() {
    const data: ServicePackaging = {
      description: '',
      name: 'New Package',
      price: 0,
      pricing: [],
      minimum_order: 1
    }
    this.serviceFormService.addPackaging([data])
  }

  public get pricing() {
    return this.packagingForm.controls[this.selectedPackage].get('pricing') as FormArray
  }

  public get hasUnits() {
    return this.packagingForm.value.length > 0
  }

  public handleAddTier() {
    this.serviceFormService.addPriceTier({ min: 0, price: 0 }, this.pricing)
  }

  public deletePackage() {
    Swal.fire({
      title: 'Are you sure?',
      confirmButtonText: 'Yes',
      type: 'warning',
      text: 'you want to delete this pricing package',
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        // get package index next to selected
        const nextPackage = this.selectedPackage === 0 ? this.selectedPackage : this.selectedPackage - 1
        if (this.selectedPackage === parseInt(this.serviceFormGroup.controls.default_package.value)) {
          this.serviceFormService.serviceFormGroup.controls.default_package.patchValue(nextPackage)
          this.serviceFormService.serviceFormGroup.controls.default_package.markAsDirty()
        }
        this.selectedPackage = nextPackage
        this.packagingForm.removeAt(this.selectedPackage)
        this.packagingForm.markAsDirty()
      }
    })
  }

  public get hasMoreThanOnePackage() {
    return this.packagingForm.value.length > 1
  }

  public handleChangeDefaultPackage($event: Event) {
    this.serviceFormService.serviceFormGroup.controls.default_package.patchValue(this.selectedPackage)
  }

  public get isSelected() {
    return this.selectedPackage === parseInt(this.serviceFormGroup.controls.default_package.value)
  }

  public get unitofMeasureSelected() {
    return this.serviceFormService.unitofMeasureIdControl.value ? true : false
  }

  public get unitofMeasure$() {
    return this.unitsOfMeasure$.pipe(
      map(units => units.find(unit => unit.id === this.serviceFormService.unitofMeasureIdControl.value))
    )
  }
}
